import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UrlPath } from "../../../../../config/routeConfig";
import { useNavigate, useParams } from "react-router-dom";
import { getProformaListAction } from "../../../../actions/proformaAction";
import { ProformasListsGrid } from "./ProformasListsGrid";
import SettingIcon from '../../../../../Images/settings.svg'
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import { AgGridReact } from "ag-grid-react";
import { SBADropDown } from "../../../../UiComponents/SBADropDown";
import { getProformaTopIndices, getRiskFreeRatio, insertSetIndex, getSetIndex, deleteSetIndex, getSetCorrelationBm, updateSetCorrelationBm,updateSetRiskFreeRatio} from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { SBACurrencyInput } from  "../../../../UiComponents/SBACurrencyInput";
import { SBNotify } from "../../../../utils/sbNotify";
export const ExistingProformas = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
    const [render, setRender] = useState(false);
    const [marketIndex, setmarketIndex] = useState([]);
    const [showSettings, setShowSetting] = useState(false);
    const [addSelectedindices, setaddSelectedindices] = useState([]);
    const [corbenchmark, setcorbenchmark] = useState([]);
    const [CorrelationBm, SetCorrelationBm] = useState([]);
    const [ratio, setRatio] = useState([]);
    const [newratio, setnewRatio] = useState([]);
  
  useEffect(() => {
      dispatch(getProformaListAction());
      getMarkedindex();
      GetRiskFreeRatio();
      GetSelectedindeces();
      GetSetCorrelationBm();
  }, [render]);

  const Gstate = useSelector((state) => state) || {};
  const isEditable =Gstate.authorizationData.isEditable;
  const ProformaList = Gstate.ProformaConstruction || [];
    const selectedIndices = useRef();
    const availableIndices = useRef();


    const getMarkedindex = async () => {
       
        try {
            const response = await sbaAxios({
                url: `${getProformaTopIndices}${false}`,
                method: 'get',
            });         
            setmarketIndex(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')
           
        };
    };

    //Get Corllection value
    const GetSetCorrelationBm = async () => {
        
        try {
            const response = await sbaAxios({
                url: `${getSetCorrelationBm}`,
                method: 'get',
            });
            if (response)
            {
                SetCorrelationBm(response);
                setcorbenchmark({ 'MarketIndexName': response.IndexName, 'MarketIndexId': response.IndexId, 'SecMasterId': response.SecurityMasterid, 'DefinitionId': response.DefinitionId })
            }
            else {
        setcorbenchmark([])
         }
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')

        };
        console.log(ratio, "ratio")
    };
    //ratio value 
    const GetRiskFreeRatio = async () => {      
        try {
            const response = await sbaAxios({
                url: `${getRiskFreeRatio}`,
                method: 'get',
            });
            setRatio(response);
            setnewRatio(response.RiskFreeRatio);
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')

        };
        console.log(ratio,"ratio")
    };
    // selected indeces
    const GetSelectedindeces = async () => {
        try {
            const response = await sbaAxios({
                url: `${getSetIndex}`,
                method: 'get',
            });
            setaddSelectedindices(response);
        }
        catch (e) {
            console.log(e, 'Error Fetching the Asset lots')

        };
    };

    const AvailableIndexColDef = [
        { headerName: "Index Name", field: "MarketIndexName"},
        { headerName: "Start Date", field: "StartDate" },
        { headerName: "End Date", field: "EndDate" }
    ];
    const SelectedIndexColDef = [
        { headerName: "Index Name", field: "IndexName" },
        
    ]
    const defColDef = { flex: 1,resizable:true }


    const AddIndices = async () => {    
        try {
            const newindices = availableIndices.current.api.getSelectedRows();                
                const response = await sbaAxios({
                    url: `${insertSetIndex}/${newindices[0].SecMasterId}`,
                    method: 'get',                 
                });
            if (response==-1) {              
                SBNotify({ Msg: "AlreadyExists", type: "error" });
            }
            else {
                console.log('Response:', response);
                GetSelectedindeces();
            }
        } catch (error) {
            console.error('Error adding indices:', error);
        }
    }



    const RemoveIndices = async () => {     
        const  deleteIndices = selectedIndices.current.api.getSelectedRows();
        try {
            const response = await sbaAxios({
                url: `${deleteSetIndex}/${deleteIndices[0].DefinitionId}`,
                method: 'get',
               
            });
            console.log('API Response:', response.data);
            GetSelectedindeces();
        } catch (error) {
            console.error('Error removing indices:', error);
        }
    };

    const savesetting = async () => {    
        const raditodefId = ratio.DefinitionId;
        const CorrelationBmID = CorrelationBm.DefinitionId
        try {
            const response = await sbaAxios({
                url: `${updateSetRiskFreeRatio}/${raditodefId},${newratio}`,
                method: 'get',

            });
            const response1 = await sbaAxios({
                url: `${updateSetCorrelationBm}/${CorrelationBmID},${corbenchmark.SecMasterId}`,
                method: 'get',

            });
            SBNotify({ Msg: " Proforma setting saved  Successfully", type: "success" });
            GetSelectedindeces();
            GetSetCorrelationBm();
            setShowSetting(false);
        } catch (error) {
            console.error('Error removing indices:', error);
        }
    };

    
  const createButtonClick = () => {
    history(`${UrlPath.NewProformaConstruction}`, { state: { ActiveButton: "CreateNewProfoma" } });
  };

  return (
    <>
      <div id="Mkdiv">
        <div className="d-flex align-items-center justify-content-between">
          <div className="col-lg-3">
            <div className="d-flex align-items-center">
              <h2 className="fw-bold fs-6 m-0">Lists of Existing Proformas</h2>
            </div>
          </div>
          <div className="col-lg-6 d-flex gap-1 justify-content-lg-end align-items-center">
            <div>
              <button type="button" className="s-sm-btn mx-1"  disabled={!isEditable} >
                Delete
              </button>
            </div>
            <div>
              <button type="button" className="s-sm-btn mx-1"  disabled={!isEditable} >
                Compare
              </button>
            </div>
            <div className="row-items">
              <button type="button" className="p-sm-btn mx-1" disabled={!isEditable} onClick={createButtonClick}>
                Create New
              </button>
               <button type="button" className="p-sm-btn mx-1" disabled={!isEditable} onClick={() => { setShowSetting(true)}}>
              <img src={SettingIcon} alt="" className="WhiteImage" /> 
              </button>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <ProformasListsGrid ProformaList={ProformaList} render={render} setRender={setRender} />
        </div>
      </div>
          <SBADrawer open={showSettings} setOpen={setShowSetting} title="Proforma Settings" size="lg" close={false} >
              <div className='gridcontent d-flex flex-row mt-3 w-100' style={{ marginBottom: "60px" }} >
                  <div className='gridDiv w-50'  >
                      <div className=''>Available Indices</div>
                      <div className="griddata ag-theme-alpine" style={{ height: '40rem' }}>
                          <AgGridReact
                              columnDefs={AvailableIndexColDef}
                              rowData={marketIndex}
                              defaultColDef={defColDef}
                              onRowDoubleClicked={{}}
                              rowSelection={'single'}
                              ref={availableIndices}
                              rowDragManaged={true}
                              animateRows={true}
                          >
                          </AgGridReact>
                      </div>
                  </div>
                  <div className='d-flex flex-column justify-content-center px-3'>
                      <button className='p-sm-btn my-1' onClick={ AddIndices}>
                          <i class="fa-solid fa-arrow-right"></i>
                      </button>
                      <button className='p-sm-btn my-1' onClick={RemoveIndices}>
                          <i class="fa-solid fa-arrow-left"></i>
                      </button>

                  </div>
                  <div className='gridDiv w-50'>
                      <div className=''>
                          Selected Indices
                     </div>
                      <div className='griddata ag-theme-alpine' style={{ height: '40rem' }}>
                          <AgGridReact
                              columnDefs={SelectedIndexColDef}
                              rowData={addSelectedindices}
                              defaultColDef={defColDef}
                              onRowDoubleClicked={{}}
                              rowSelection={'single'}
                              ref={selectedIndices}
                              rowDragManaged={true}
                              animateRows={true}
                              onRowDragEnd={{}}
                              allowContextMenuWithControlKey={true}
                              getContextMenuItems={{}}
                              onGridReady={(params) => {
                                  params.api.sizeColumnsToFit()
                              }}
                              onRowDragLeave={{}}
                          >
                          </AgGridReact>
                      </div>
                  </div>
              </div>
              <div className="row my-3">

                  <label className="col-md-3">Risk Free Return
      </label>
                  <div className="col-md-4 p-0">                  
                      <SBACurrencyInput
                          className={"form-control w-75"}
                          decimalsLimit={4}
                          value={newratio?newratio: '0.0000'}
                          onBlur={(e) => {
                              const parsedValue = parseFloat(e);
                              setnewRatio(parsedValue);
                          }}
                          disableGroupSeparators={false}
                      />
                  </div>
                  <div className="col" style={{marginLeft:"-75px"}}>%</div>
              </div>
              <div className="row my-3" >
                  <label className="col-md-3">Correlation Benchmark
      </label>
                  <SBADropDown className="col-md-4" popupSettings={{ className: 'modalDD' }}
                      data={marketIndex} textField={'MarketIndexName'} valueField={'MarketIndexId'} value={corbenchmark}
                      onChange={(event) => {                    
                          setcorbenchmark(event.value)
                      }}
                  />            
              </div>
              <div className="d-flex flex-row my-3" >
                  
                  <button className="s-sm-btn mx-1" onClick={() => setShowSetting(false)}> Cancel</button>
                  <button className="p-sm-btn mx-1" onClick={savesetting}> Save </button>
              </div>
    </SBADrawer>
    </>
  );
};



